import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@nextui-org/react";
import { type WhitelistDomain } from "../../requests/whitelist";

interface RemoveDomainModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  domain: WhitelistDomain | null;
  isLoading?: boolean;
}

const RemoveDomainModal = ({ isOpen, onClose, onConfirm, domain, isLoading = false }: RemoveDomainModalProps) => {
  const displayDomain = domain?.email_domain || "";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      classNames={{
        wrapper: "z-[9999]",
        backdrop: "bg-black/50",
      }}
    >
      <ModalContent className="py-4">
        <ModalHeader className="flex flex-col gap-1 px-6 pb-2 items-center">
          <h3 className="text-lg font-semibold text-gray-900 text-center leading-tight">
            Are You Sure You Want to Remove {displayDomain}?
          </h3>
        </ModalHeader>
        <ModalBody className="px-6 py-2 items-center">
          <p className="text-sm text-gray-600 text-center">
            Removing this domain revokes onboarding access for future external users associated with it.
          </p>
        </ModalBody>
        <ModalFooter className="px-6 pt-4">
          <Button variant="bordered" onPress={onClose} className="flex-1" isDisabled={isLoading}>
            Cancel
          </Button>
          <Button color="danger" onPress={onConfirm} className="flex-1" isLoading={isLoading} isDisabled={isLoading}>
            Yes, Remove
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RemoveDomainModal;
